import { render, staticRenderFns } from "./LcNavBack.vue?vue&type=template&id=33d3ec72&scoped=true"
import script from "./LcNavBack.vue?vue&type=script&lang=js"
export * from "./LcNavBack.vue?vue&type=script&lang=js"
import style0 from "./LcNavBack.vue?vue&type=style&index=0&id=33d3ec72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33d3ec72",
  null
  
)

export default component.exports